<div class="position-fixed w-100 header-wrapper">
  <app-accessibility-nav></app-accessibility-nav>
  <app-navbar></app-navbar>
</div>

@if (renderLandingContent) {
  <section>
    <router-outlet></router-outlet>
  </section>
}

@if (renderFooterContent) {
  <app-footer></app-footer>
}